//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Geneva',
  data() {
    return {
      defaultJson: {
        "Cancer": "恶性肿瘤",
        "Past History of DVT": "深静脉血栓（DVT）病史",
        "PaO2 < 8 kPa (60 mmHg)": "PaO₂ < 60 mmHg",
        "Heart Failure": "心力衰竭",
        "Low risk (2%) of bad outcome": "不良预后低危（2%）",
        "Systolic BP < 100 mmHg": "收缩压 < 100 mmHg",
        "High risk (26%) of bad outcome": "不良预后高危（26%）",
        "Proximal DVT": "超声证实存在DVT"
      },
      form: {
        cancer: '0',
        heart: '0',
        olddvt: '0',
        sys: '0',
        po2: '0',
        acutedvt: '0',

      },
      hasScore: false,
      disabled: false,
      Multifocal_Candida_Colonization_hint: "Candida is simultaneously isolated from various noncontagious foci:\n\nfeces\/rectal swabs or\nurine or\nrespiratory or\nskin or\noropharynx\/stomach",
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '0'
      } else {
        // 	(cancer *  2) + heart  + olddvt  + (sys *  2)  + po2  + acutedvt
        let result = (form.cancer * 2) + (form.heart * 2) + form.olddvt + (form.sys * 2) + form.po2 + form.acutedvt

        self.hasScore = true
        return String(result)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/Geneva.vue